<template>
  <div class="pc-class">
    <!-- Header區 開始 -->
    <header class="header">
      <!-- 選單區 開始 -->
      <input type="checkbox" name="" id="menu_control" @click="clickMenu" v-model="isClick">
      <div class="top">
        <h1 class="logo">
          <a href="#">
            <img :src="logo" alt="logo" @click="toIndex">
          </a>
        </h1>
        <label for="menu_control" class="menubtn">
          <span v-for="item in 3" :key="item"></span>
        </label>
        <transition name="slide">
          <nav class="menu">
            <ul>
              <a href="#">
                <img class="menulogo" :src="menuLogo" alt="menulogo">
              </a>
              <li v-for="(item, index) in navItems" :key="index" class="sub">
                <span @click="clickMenu" v-if="item.item.length === 1">
                  <router-link :to="item.item[0].path" :key="'span-'+index" >{{item.item[0].name}}</router-link>
                </span>
                <template v-else>
                  <span>{{item.name}}</span>
                  <input type="checkbox" name="" :id="`submenu_control_${index + 1}`">
                  <label :for="`submenu_control_${index + 1}`" :class="`submenubtn${index + 1}`"></label>
                  <ol>
                    <li v-for="(subItem,subIndex) in item.item" :key="subIndex" class="first_li" @click="clickMenu">
                      <router-link :to="subItem.path">{{subItem.name}}</router-link>
                    </li>
                  </ol>
                </template>
              </li>
            </ul>
          </nav>
        </transition>
        <!-- 選單區 結束 -->
        <!-- 右側icon區 開始 -->
        <transition name="icon">
          <div class="icon">
            <div v-for="(item, index) in iconList" :key="index" class="small-icon">
              <img :class="item.className" :src="item.img" @click="clickIcon(item)">
            </div>
            <!--我的最愛 開始-->
            <Drawer class="my-favorite-mask" v-model="isFavoriteClick" :closable="false" :transfer="false">
              <div class="my-favorite">
                <h5 class="empty-text" v-if="isFavoriteEmpty">Your wish list is empty.</h5>
                <h5 class="save-text" v-else>Saved Items</h5>
                <div v-for="(item, index) in favoriteList" :key="index" class="my-favorite-box">
                  <img :src="item.img" alt="">
                  <div class="my-favorite-text">
                    <h5>{{item.text}}</h5>
                    <p>{{`$${formatNum(item.price)}`}}</p>
                    <Button @click="addCart(item)">Add to cart</Button>
                  </div>
                  <div class="my-favorite-cross" @click="removeFavoriteItem(item)">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            </Drawer>
            <!--我的最愛 結束-->
            <!--購物車 開始-->
            <Drawer class="my-favorite-mask" v-model="isCartClick" :closable="false" :transfer="false">
              <div class="my-cart">
                <h5 class="empty-text" v-if="isCartEmpty">Your Shopping Cart is empty.</h5>
                <h5 class="save-text" v-else>Your Shopping Cart</h5>
                <div v-for="(item, index) in cartList" :key="index" class="my-cart-box">
                  <img :src="item.img" alt="">
                  <div class="my-cart-text">
                    <h5>{{item.text}}</h5>
                    <p>{{`$${formatNum(item.price)}`}}</p>
                  </div>
                  <div class="my-cart-cross" @click="removeCartItem(item)">
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div class="total-amount" v-if="!isCartEmpty">{{`Total：$${formatNum(totalAmount)}`}}</div>
              </div>
            </Drawer>
            <!--購物車 結束-->
          </div>
        </transition>
        <!-- 右側icon區 結束 -->
      </div>
    </header>
    <!-- Header區 結束 -->
    <main>
      <router-view />
    </main>
    <!-- Footer區 開始-->
    <footer class="footer">
      <a href="#"><h5>＾</h5></a>
      <div class="footerlist">
        <ul>
          <li>
            <router-link to="/Earrings">JEWELRY</router-link>
          </li>
          <li>
            <router-link to="/About">ABOUT</router-link>
          </li>
          <li>
            <router-link to="/Store">CONTACT US</router-link>
          </li>
        </ul>
      </div>
      <div class="footericon">
        <ul>
          <li v-for="(item, index) in footerIconList" :key="index">
            <img :src="item.img" alt="">
          </li>
        </ul>
      </div>
      <div class="news">
        <h4>OUR NEWSLETTER</h4>
          <div class="input-outter">
            <Input type="email" class="email" name="" value="" placeholder="ENTER YOUR EMAIL HERE" />
            <Button>></Button>
          </div>
      </div>
      <div class="copyright">
        <p>Copyright ©2021 EMMA LEE. All rights reserved</p>
      </div>
      <div class="clearfix"></div>
    </footer>
    <!-- Footer區 結束-->
  </div>
</template>

<script>
import platformConfig from '@/config/PlatformConfig'
import { mapState } from 'vuex'
import { formatNum } from '@/util/number'
import menuLogo from '@/assets/mobile/main/logo_white_shadow.png'
import hreartIcon from '@/assets/pc/main/icon_hreart.png'
// import searchIcon from '@/assets/pc/main/icon_search.png'
import logninIcon from '@/assets/pc/main/icon_lognin.png'
import cartIcon from '@/assets/pc/earrings/hover_icon_cart02.png'
import fbIcon from '@/assets/pc/main/icon_fb.png'
import pinterestIcon from '@/assets/pc/main/icon_pinterest.png'
import twriterIcon from '@/assets/pc/main/icon_twriter.png'
import igIcon from '@/assets/pc/main/icon_ig.png'
import { defaultRoute } from '@/main'

export default {
  watch: {
  },
  computed: {
    isPhone () {
      return navigator.userAgent.includes('Mobile')
    },
    ...mapState({
      favoriteList: state => state.product.favoriteList,
      cartList: state => state.product.cartList
    }),
    isFavoriteEmpty () {
      return this.favoriteList.length === 0
    },
    isCartEmpty () {
      return this.cartList.length === 0
    },
    totalAmount () {
      let total = 0
      this.cartList.forEach(item => {
        total += item.price
      })
      return total
    }
  },
  mounted () {
    this.menuInitial()
  },
  data () {
    return {
      isClick: false,
      isFavoriteClick: false,
      isCartClick: false,
      formatNum,
      logo: platformConfig.logo,
      menuLogo,
      iconList: [
        { img: hreartIcon, className: 'hreart', method: this.showFavorite },
        { img: cartIcon, className: 'cart', method: this.showCart },
        { img: logninIcon, className: 'lognin', method: () => {} }
      ],
      allRoutes: defaultRoute[0].children,
      navItems: [],
      menuShowItem: ['JEWELRY', 'COLLECTIONS', 'BESPOKE', 'ABOUT', 'STORE'],
      openNames: [],
      locale: platformConfig.locale,
      activeIndex: '0',
      footerIconList: [
        { img: fbIcon },
        { img: pinterestIcon },
        { img: igIcon },
        { img: twriterIcon }
      ]
    }
  },
  methods: {
    menuInitial () {
      this.openNames = sessionStorage.getItem('activeNav') === null ? ['0'] : [sessionStorage.getItem('activeNav').substr(0, 1)]
      const emptyMenu = []
      const newMenu = []
      this.allRoutes.forEach(route => {
        const rawRouteNameArray = route.id.split('-')
        const routeName = rawRouteNameArray[0]
        if (newMenu.indexOf(routeName) === -1 && this.menuShowItem.findIndex(item => item === routeName) !== -1) newMenu.push(routeName)
      })
      newMenu.forEach(item => {
        emptyMenu.push({ name: item, item: [] })
      })
      this.allRoutes.forEach(routeItem => {
        const routeName = routeItem.id.split('-')[0]
        emptyMenu.forEach((menuItem, index, thisArray) => {
          if (routeName === menuItem.name) {
            thisArray[index].item.push(routeItem)
          }
        })
      })
      this.navItems = emptyMenu
    },
    langChange (value) {
      sessionStorage.setItem('locale', value)
      window.location.reload()
    },
    toIndex () {
      this.$router.push('/index')
    },
    clickMenu () {
      this.isClick = !this.isClick
    },
    clickIcon (item) {
      item.method()
    },
    showFavorite () {
      this.isFavoriteClick = true
    },
    addCart (item) {
      // 移除ADD
      item.favoriteStatus = 0
      document.getElementById(`icon-heart-${item.id}`).classList.remove('icon-color')
      this.$store.dispatch('removeFavoriteItem', item)
      // 增加CART
      const index = this.cartList.findIndex(cartItem => cartItem.id === item.id)
      if (item.cartStatus === 0 && index === -1) {
        document.getElementById(`icon-cart-${item.id}`).classList.add('icon-color')
        item.cartStatus = 1
        this.cartList.push(item)
      } else {
        document.getElementById(`icon-cart-${item.id}`).classList.remove('icon-color')
        item.cartStatus = 0
        this.cartList.splice(index, 1)
      }
      this.$store.dispatch('addCartList', this.cartList)
    },
    showCart () {
      this.isCartClick = true
    },
    removeFavoriteItem (item) {
      item.favoriteStatus = 0
      document.getElementById(`icon-heart-${item.id}`).classList.remove('icon-color')
      this.$store.dispatch('removeFavoriteItem', item)
    },
    removeCartItem (item) {
      item.favoriteStatus = 0
      document.getElementById(`icon-cart-${item.id}`).classList.remove('icon-color')
      this.$store.dispatch('removeCartItem', item)
    }
  }
}
</script>

<style lang="scss">
.pc-class {
  .ivu-layout {
    position: relative;
    /* header開始 */
    .ivu-layout-header {
      height: 60px;
      line-height: 60px;
      padding: 0 30px;
      .header-logo {
        display: flex;
        align-items: center;
        img {
          width: 150px;
          display: block;
          cursor: pointer;
        }
      }
      .ivu-select {
        width: 80px;
      }
      // 選單開始
      .ivu-menu-horizontal {
        .ivu-menu-item {
          color: #fff;
          &:hover {
            color: #ffac5a;
          }
        }
        .ivu-menu-item-active {
          color: #ffac5a;
        }
        .ivu-menu-submenu {
          &:hover {
            background-color: #004077;
          }
          span {
            color: #fff;
          }
          .ivu-select-dropdown {
            background-color: #004077;
            margin-top: 0;
            .ivu-menu-item {
              &:hover {
                background-color: #2563af;
              }
            }
          }
        }
      }
      // 選單結束
    }
    /* header結束 */
    .content-wrap {
      background-color: #fff;
      min-height: 87vh;
      position: relative;
    }
  }
/* to-top按鈕開始 */
  .top-img {
    display: block;
    width: 80%;
  }
/* to-top按鈕結束 */
/* 選單效果開始 */
  .slide-enter-active,
  .slide-leave-active
  {
    transition: transform .5s ease;
  }
  .slide-enter,
  .slide-leave-to {
    transform: translateY(-100%);
    transition: all 150ms ease-in .5s
  }
  /* 選單效果結束 */
  /* icon效果開始 */
  .icon-enter-active,
  .icon-leave-active
  {
    opacity: 0;
    transition: opacity .5s ease;
  }
  .icon-leave-to {
    opacity: 0;
  }
  /* icon效果結束 */
}
// *--------------------------PC版 開始--------------------------
@media screen and (min-width: 768px) {
  .pc-class {
    .ivu-layout {
      .content-wrap {
        background-color: #004077;
        min-height: 87vh;
      }
    }
  }
}

</style>
